import { render, staticRenderFns } from "./index.vue?vue&type=template&id=709304cd&scoped=true&lang=html&"
import script from "./goodsClassification.js?vue&type=script&lang=js&"
export * from "./goodsClassification.js?vue&type=script&lang=js&"
import style0 from "./goodsClassification.styl?vue&type=style&index=0&id=709304cd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709304cd",
  null
  
)

export default component.exports